import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// Heroicons solid "sun" - Figma's icon for "Unfreeze cards", distinct from Freeze's snowflake
// (both used to share the same snowflake icon before this).
const Sun = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none">
    <path
      d="M24 4.5C24.8284 4.5 25.5 5.17157 25.5 6V10.5C25.5 11.3284 24.8284 12 24 12C23.1716 12 22.5 11.3284 22.5 10.5V6C22.5 5.17157 23.1716 4.5 24 4.5Z"
      fill="currentColor"
    />
    <path
      d="M15 24C15 19.0294 19.0294 15 24 15C28.9706 15 33 19.0294 33 24C33 28.9706 28.9706 33 24 33C19.0294 33 15 28.9706 15 24Z"
      fill="currentColor"
    />
    <path
      d="M37.7887 12.3327C38.3745 11.7469 38.3745 10.7971 37.7887 10.2114C37.2029 9.62557 36.2532 9.62557 35.6674 10.2114L32.4854 13.3933C31.8996 13.9791 31.8996 14.9289 32.4854 15.5147C33.0712 16.1004 34.0209 16.1004 34.6067 15.5147L37.7887 12.3327Z"
      fill="currentColor"
    />
    <path
      d="M43.5 24C43.5 24.8284 42.8284 25.5 42 25.5H37.5C36.6716 25.5 36 24.8284 36 24C36 23.1716 36.6716 22.5 37.5 22.5H42C42.8284 22.5 43.5 23.1716 43.5 24Z"
      fill="currentColor"
    />
    <path
      d="M35.6671 37.7885C36.2529 38.3743 37.2027 38.3743 37.7885 37.7885C38.3742 37.2027 38.3742 36.253 37.7885 35.6672L34.6065 32.4852C34.0207 31.8994 33.0709 31.8994 32.4852 32.4852C31.8994 33.071 31.8994 34.0207 32.4852 34.6065L35.6671 37.7885Z"
      fill="currentColor"
    />
    <path
      d="M24 36C24.8284 36 25.5 36.6716 25.5 37.5V42C25.5 42.8284 24.8284 43.5 24 43.5C23.1716 43.5 22.5 42.8284 22.5 42V37.5C22.5 36.6716 23.1716 36 24 36Z"
      fill="currentColor"
    />
    <path
      d="M15.515 34.6065C16.1008 34.0208 16.1008 33.071 15.515 32.4852C14.9292 31.8994 13.9795 31.8994 13.3937 32.4852L10.2117 35.6672C9.62592 36.253 9.62592 37.2027 10.2117 37.7885C10.7975 38.3743 11.7472 38.3743 12.333 37.7885L15.515 34.6065Z"
      fill="currentColor"
    />
    <path
      d="M12 24C12 24.8284 11.3284 25.5 10.5 25.5H6C5.17157 25.5 4.5 24.8284 4.5 24C4.5 23.1716 5.17157 22.5 6 22.5H10.5C11.3284 22.5 12 23.1716 12 24Z"
      fill="currentColor"
    />
    <path
      d="M13.3935 15.5146C13.9792 16.1004 14.929 16.1004 15.5148 15.5146C16.1006 14.9289 16.1006 13.9791 15.5148 13.3933L12.3328 10.2113C11.747 9.62555 10.7973 9.62555 10.2115 10.2113C9.62569 10.7971 9.62569 11.7469 10.2115 12.3327L13.3935 15.5146Z"
      fill="currentColor"
    />
  </svg>
);

export default Sun;
